import { v4 as uuidv4 } from "uuid";
import Bg1 from "../../assets/img/home1/eng.jpg";
import Bg3 from "../../assets/img/home1/eng2.jpg";
import Bg4 from "../../assets/img/home1/gas.jpg";
import Bg2 from "../../assets/img/home1/power.jpg";
import Icon1 from "../../assets/img/icon/s1.png";
import Icon2 from "../../assets/img/icon/s2.png";
import Icon3 from "../../assets/img/icon/s3.png";
import Icon4 from "../../assets/img/icon/s4.png";

const servicesOneData = [
  {
    id: uuidv4(),
    bgImg: Bg1,
    icon: Icon1,
    heading: "Forging Vendors",
    btnText: "Learn More",
  },

  {
    id: uuidv4(),
    bgImg: Bg2,
    icon: Icon2,
    heading: "Machining Vendors",
    btnText: "Learn More",
  },

  {
    id: uuidv4(),
    bgImg: Bg3,
    icon: Icon3,
    heading: "Sheet Metal Vendors",
    btnText: "Learn More",
  },

  {
    id: uuidv4(),
    bgImg: Bg4,
    icon: Icon4,
    heading: "Extrusion Vendors",
    btnText: "Learn More",
  },

  {
    id: uuidv4(),
    bgImg: Bg1,
    icon: Icon1,
    heading: "Surface Treatment Vendors",
    btnText: "Learn More",
  },

  {
    id: uuidv4(),
    bgImg: Bg2,
    icon: Icon2,
    heading: "Heat Treatment Vendors",
    btnText: "Learn More",
  },

  {
    id: uuidv4(),
    bgImg: Bg3,
    icon: Icon3,
    heading: "Fabrication Vendors",
    btnText: "Learn More",
  },
];

export default servicesOneData;
